import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { customerHubMainFooterStacks, customerHubPressFooterStack } from '../../config/customer-hub-footer.config';
import { DateService } from '../../feature-modules/shared/services/date.service';
import {
  selectCustomerAttributes,
  selectCustomerAttributesError,
} from 'src/app/feature-modules/customer-attributes/store/customer-attributes.selector';
import { BeLogoV2Component } from '../../feature-modules/shared/components/be-logo-v2/be-logo-v2.component';
import { AppStoreLinksComponent } from '../../feature-modules/customer-hub/components/app-store-links/app-store-links.component';
import { displayMobileCard } from '../../feature-modules/accounts/store/accounts.selector';

@Component({
  selector: 'app-simplified-footer',
  templateUrl: './simplified-footer.component.html',
  styleUrls: ['./simplified-footer.component.scss'],
  imports: [CommonModule, BeLogoV2Component, AppStoreLinksComponent],
})
export class SimplifiedFooterComponent {
  displayMobileCard = this.store.selectSignal(displayMobileCard);
  mainFooterStacks = customerHubMainFooterStacks;
  pressFooterStack = customerHubPressFooterStack;
  currentYear = new Date().getFullYear();
  quoteAsOfDate = this.store.select(selectCustomerAttributes).pipe(
    filter((val) => val !== null),
    withLatestFrom(this.store.select(selectCustomerAttributesError)),
    map(([customerAttributes, error]) => {
      if (error || !customerAttributes.timestamp) {
        return 'n/a';
      }
      return this.datePipe.transform(this.dateService.getDaysIntoPast(customerAttributes.timestamp, 1), 'M/d/yyyy');
    })
  );

  @Input() showPayoffDisclosures = true;

  constructor(
    private readonly store: Store,
    private readonly dateService: DateService,
    private readonly datePipe: DatePipe
  ) {}
}
